import Image from "next/image";
import Meta from "@/components/templates/Meta";
import { Header } from "@/components/templates/Header";
import { Footer } from "@/components/templates/Footer";
import Layout from "@/components/templates/Layout";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { TLink } from "@/components/molecules/Button";
import { useBudouX } from "@/hooks/useBudouX";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Contact from "@/components/organisms/Contact";
import { Interviewee, Interviewer } from "@/components/organisms/InterviewItem";
import { VoiceCover } from "@/components/organisms/VoiceCover";
import { VoiceNav } from "@/components/organisms/VoiceNav";
import voicePhoto from "/public/voice-photo6.webp";
import voicePhotoB from "/public/voice-photo6b.webp";

export default function CareerArticle6(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={
          "Voices:メンバーの声 No.6 前職のキャリアを活かしたクライアントとの信頼構築"
        }
        pageDescription={
          "株式会社トッカシステムズのVoices:メンバーの声 No.6 前職のキャリアを活かしたクライアントとの信頼構築。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/careers/voice/6"}
      />
      <Layout className="relative">
        <div className="absolute z-0 aspect-1/1 w-full bg-voices-no6 xs:max-h-[300px] sm:max-h-[300px] md:aspect-1/1 md:max-h-[500px] lg:max-h-[640px]"></div>
        <Header isRelative={isHeaderRelative} />
        <main className="z-10 flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Careers",
                  path: "/",
                },
                {
                  name: "Voices:メンバーの声 No.6",
                },
              ]}
            />
            <Inner className="max-w-full">
              <div className="mx-auto flex max-w-6xl flex-col">
                <VoiceCover
                  title="前職のキャリアを活かしたクライアントとの信頼構築"
                  avatar="M.Tさん - 2020年入社"
                />
                <figure className="relative mt-6 block aspect-2/1 w-full group-hover:opacity-80 md:mt-8 lg:mt-10">
                  <Image
                    src={voicePhoto}
                    alt="前職のキャリアを活かしたクライアントとの信頼構築 M.Tさん - 2020年入社"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </figure>
              </div>
              <div
                className="mx-auto
                max-w-2xl
                space-y-3
                py-6
                leading-loose
                text-txt-base
                md:space-y-4
                md:py-8
                lg:space-y-6
                lg:pt-14
                lg:pb-20"
              >
                <Interviewer>
                  ToccaSystemsに入った時の印象を教えてください。
                </Interviewer>
                <Interviewee>
                  私は、IT業界との携わりが全くなかったので、堅いイメージがありました。
                  でも入社したら、皆さん和気あいあいとしていて、『あれ？思っていたのとは違う！』(笑)
                  ただ業務に集中する時は集中。メリハリがあるんです。
                  業務が終了すると、ご飯に行ったり、親しみやすい会社でした。
                </Interviewee>
                <Interviewer>
                  普段はどのような雰囲気・スタイル・服装などでお仕事をされていますか？
                </Interviewer>
                <Interviewee>
                  営業なので基本的にはスーツスタイルです。
                  外出が減り、Web会議などが増えてきた今では、すっかりオフィスカジュアルになりました。
                </Interviewee>
                <Interviewer>
                  前職のここが活きていると、業務上で感じるところはどんなところですか？
                </Interviewer>
                <Interviewee>
                  営業職としてキャリアを積んできたので、クライアントのニーズを掴むことが特に活かされていると感じています。
                  お客様から信頼されていると実感した時は、営業としての自信にもなりますし楽しいです。
                </Interviewee>
                <div className="relative aspect-1.91/1">
                  <Image
                    src={voicePhotoB}
                    alt="【Voices: メンバーの声 No.6】 インタビューカット"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                <Interviewer>
                  思い通りにいかないことはありませんか？そんな時はどうしていますか？
                </Interviewer>
                <Interviewee>
                  思い通りにならないというか、わからないことがあれば、質問して吸収しています。自分の頭で処理できない時は、あえて寝ます。一旦忘れようと。(笑)
                </Interviewee>
                <Interviewer>
                  今後挑戦したいことや取り組んでいきたいことを教えてください。
                </Interviewer>
                <Interviewee>
                  クライアントのために、より良い提案ができる営業を目指しています。
                  そのためにも更に知識を蓄えたいと思い、1日30分でも勉強しています。
                  業務において必要になる資格もあるので、『資格取得推奨制度』を活用して、資格取得のためにも日々勉強です。
                </Interviewee>
                <Interviewer>
                  最後に一緒に働いてみたいと思うのはどんな人か教えてください。
                </Interviewer>

                <Interviewee>
                  好奇心が旺盛な人ですね。私自身、新しい業界に飛び込んで、刺激を受けながら働いているので、刺激しあって自分自身も成長していければ嬉しいですね。一緒にがんばりましょう。
                </Interviewee>
                <div className="flex justify-end px-8 md:px-0">
                  <TLink href="/careers/" variant="mono" color="ff">
                    Carrers top
                  </TLink>
                </div>
              </div>
              <VoiceNav />
            </Inner>
          </Container>
        </main>
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
